import React, { useEffect, useState, useRef } from "react";
import "./CampoLuzes.css";
import { LightGroup } from "../Classes/LightGroup";
import Ligado from "../../assets/img/Ligado.png";
import Desligado from "../../assets/img/Desligado.png";
import { getLuzesStatusFlex35, statusDasLuzesFlex35 } from "../../API/FeedBackLuzes";

const GroupLightComponent = () => {
  const groupRefs = useRef({
    grupo01: React.createRef(),
    grupo02: React.createRef(),
    grupo03: React.createRef(),
    grupo04: React.createRef(),
    grupo06: React.createRef(),
    grupo26: React.createRef(),
    grupo28: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo01: false,
    grupo02: false,
    grupo03: false,
    grupo04: false,
    grupo06: false,
    grupo26: false,
    grupo28: false,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      updateLightGroup();
      setLoading(false);
      console.log("Status das luzes:", statusDasLuzesFlex35);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8300);
  
    return () => clearInterval(intervalId);
  }, []);

  const updateLightGroup = () => {
    setImageStates({
      grupo01: statusDasLuzesFlex35.includes("1A10") && !statusDasLuzesFlex35.includes("1A00"),
      grupo02: statusDasLuzesFlex35.includes("1B10") && !statusDasLuzesFlex35.includes("1B00"),
      grupo03: statusDasLuzesFlex35.includes("1C10") && !statusDasLuzesFlex35.includes("1C00"),
      grupo04: statusDasLuzesFlex35.includes("1D10") && !statusDasLuzesFlex35.includes("1D00"),
      grupo06: statusDasLuzesFlex35.includes("1F10") && !statusDasLuzesFlex35.includes("1F00"),
      grupo26: statusDasLuzesFlex35.includes("1Z10") && !statusDasLuzesFlex35.includes("1Z00"),
      grupo28: statusDasLuzesFlex35.includes("1b10") && !statusDasLuzesFlex35.includes("1b00"),
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <>
      <div className="group" id="campoGroup-pagina1">
        {/* Grupo 01 */}
        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={20.2}
          y={35.2}
          width={1.75}
          height={3}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={13.4}
          y={82}
          width={1.75}
          height={3}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={21.8}
          y={45.2}
          width={1.75}
          height={3}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={20.8}
          y={56.3}
          width={1.75}
          height={3}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={15.6}
          y={66.1}
          width={1.75}
          height={3}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={19.3}
          y={75.3}
          width={1.75}
          height={3}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={17.5}
          y={53.3}
          width={1.75}
          height={3}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={19.8}
          y={64.3}
          width={1.75}
          height={3}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Postes"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={19}
          y={43.8}
          width={1.75}
          height={3}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />


        {/* Grupo 02 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Degraus / Portíco"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado}
          onCommand="1B10"
          offCommand="1B00"
          x={24.3}
          y={60.2}
          width={1.75}
          height={3}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 03 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Espetos"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={23.3}
          y={47.8}
          width={1.75}
          height={3}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Espetos"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={29}
          y={45.4}
          width={1.75}
          height={3}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Espetos"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={16.8}
          y={76}
          width={1.75}
          height={3}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Espetos"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={17.8}
          y={65.3}
          width={1.75}
          height={3}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Espetos"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={27.7}
          y={53.2}
          width={1.75}
          height={3}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Espetos"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={17.7}
          y={56.6}
          width={1.75}
          height={3}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Espetos"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={28.3}
          y={66.8}
          width={1.75}
          height={3}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Espetos"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={32.4}
          y={75.3}
          width={1.75}
          height={3}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 04 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo04}
          groupId="grupo04"
          descricao="Arandelas Veículos"
          imageUrl={imageStates.grupo04 ? Ligado : Desligado}
          onCommand="1D10"
          offCommand="1D00"
          x={25.9}
          y={38.7}
          width={1.75}
          height={3}
          imageState={imageStates.grupo04}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo04}
          groupId="grupo04"
          descricao="Arandelas Veículos"
          imageUrl={imageStates.grupo04 ? Ligado : Desligado}
          onCommand="1D10"
          offCommand="1D00"
          x={32.2}
          y={38.8}
          width={1.75}
          height={3}
          imageState={imageStates.grupo04}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 06 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo06}
          groupId="grupo06"
          descricao="Tomadas gourmet"
          imageUrl={imageStates.grupo06 ? Ligado : Desligado}
          onCommand="1F10"
          offCommand="1F00"
          x={39.4}
          y={68.1}
          width={1.75}
          height={3}
          imageState={imageStates.grupo06}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 26 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo26}
          groupId="grupo26"
          descricao="Circulação Térreo"
          imageUrl={imageStates.grupo26 ? Ligado : Desligado}
          onCommand="1Z10"
          offCommand="1Z00"
          x={37}
          y={61.6}
          width={1.75}
          height={3}
          imageState={imageStates.grupo26}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 29 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo28}
          groupId="grupo28"
          descricao="Corredor Rota de Fuga"
          imageUrl={imageStates.grupo28 ? Ligado : Desligado}
          onCommand="1\\10"
          offCommand="1\\00"
          x={43.2}
          y={78}
          width={1.75}  
          height={3}
          imageState={imageStates.grupo28}
          onToggleLightGroup={handleToggleLightGroup}
        />  

        {/* Botões para clicar em cima da legenda */}
        <div
          className="campoGroup-clickable-element"
          style={{ top: '66.4%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo01', !imageStates.grupo01); groupRefs.current.grupo01.current.sendCommand(groupRefs.current.grupo01.current.props.descricao, imageStates.grupo01 ? groupRefs.current.grupo01.current.props.offCommand : groupRefs.current.grupo01.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo01 ? 'Highlighted' : ''}`}>1</p>
          <p className="textBar">Postes</p>
        </div>
        <div
          className="campoGroup-clickable-element"
          style={{ top: '70.5%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo02', !imageStates.grupo02); groupRefs.current.grupo02.current.sendCommand(groupRefs.current.grupo02.current.props.descricao, imageStates.grupo02 ? groupRefs.current.grupo02.current.props.offCommand : groupRefs.current.grupo02.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo02 ? 'Highlighted' : ''}`}>2</p>
          <p className="textBar">Degraus / Portíco</p>
        </div>
        <div
          className="campoGroup-clickable-element"
          style={{ top: '74.7%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo03', !imageStates.grupo03); groupRefs.current.grupo03.current.sendCommand(groupRefs.current.grupo03.current.props.descricao, imageStates.grupo03 ? groupRefs.current.grupo03.current.props.offCommand : groupRefs.current.grupo03.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo03 ? 'Highlighted' : ''}`}>3</p>
          <p className="textBar">Espetos</p>          
        </div>
        <div
          className="campoGroup-clickable-element"
          style={{ top: '78.9%', left: '80%' }}
          onClick={() => { handleToggleLightGroup('grupo04', !imageStates.grupo04); groupRefs.current.grupo04.current.sendCommand(groupRefs.current.grupo04.current.props.descricao, imageStates.grupo04 ? groupRefs.current.grupo04.current.props.offCommand : groupRefs.current.grupo04.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo04 ? 'Highlighted' : ''}`}>4</p>
          <p className="textBar">Arandelas Veículos</p>          
        </div>
        <div
          className="campoGroup-clickable-element"
          style={{ top: '83%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo06', !imageStates.grupo06); groupRefs.current.grupo06.current.sendCommand(groupRefs.current.grupo06.current.props.descricao, imageStates.grupo06 ? groupRefs.current.grupo06.current.props.offCommand : groupRefs.current.grupo06.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo06 ? 'Highlighted' : ''}`}>6</p>
          <p className="textBar">Tomadas gourmet</p>          
        </div>
        <div
          className="campoGroup-clickable-element"
          style={{ top: '87.2%', left: '80%' }}
          onClick={() => {handleToggleLightGroup('grupo26', !imageStates.grupo26); groupRefs.current.grupo26.current.sendCommand(groupRefs.current.grupo26.current.props.descricao, imageStates.grupo26 ? groupRefs.current.grupo26.current.props.offCommand : groupRefs.current.grupo26.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo26 ? 'Highlighted' : ''}`}>26</p>
          <p className="textBar">Circulação Térreo</p>          
        </div>
        <div
          className="campoGroup-clickable-element"
          style={{ top: '91.2%', left: '80%' }}
          onClick={() => {
            handleToggleLightGroup('grupo28', !imageStates.grupo28);
            groupRefs.current.grupo28.current.sendCommand(groupRefs.current.grupo28.current.props.descricao, imageStates.grupo28 ? groupRefs.current.grupo28.current.props.offCommand : groupRefs.current.grupo28.current.props.onCommand);
          }}
        >
          <p className={`NumberTextBar${imageStates.grupo28 ? 'Highlighted' : ''}`}>28</p>
          <p className="textBar">Rota de Fuga</p>              
        </div>
      </div>
    </>
  );
};

export default React.memo(GroupLightComponent);